import { render, staticRenderFns } from "./PopupFooterOneButton.vue?vue&type=template&id=05edeb8d&scoped=true&"
import script from "./PopupFooterOneButton.vue?vue&type=script&lang=js&"
export * from "./PopupFooterOneButton.vue?vue&type=script&lang=js&"
import style0 from "./PopupFooterOneButton.vue?vue&type=style&index=0&id=05edeb8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05edeb8d",
  null
  
)

export default component.exports